import Lozenge from '@atlaskit/lozenge';
import { defaultStoreUtils } from '@databases/redux';
import { type JiraIssueRef } from '@databases/types/confluence';
import { selectJiraIssueOptional } from '@databases/utils/redux/jira/selectors';
import React, { type FunctionComponent } from 'react';

const JiraIssueStatus: FunctionComponent<{ issue: JiraIssueRef }> = ({ issue }) => {
  const [resolvedIssue] = defaultStoreUtils.useShallowEqualSelector((state) => {
    return [selectJiraIssueOptional(state, issue)] as const;
  });

  return resolvedIssue ? (
    <Lozenge
      appearance={
        resolvedIssue.statusCategory === 'in-progress'
          ? 'inprogress'
          : resolvedIssue.statusCategory === 'done'
          ? 'success'
          : undefined
      }
    >
      {resolvedIssue.statusName}
    </Lozenge>
  ) : null;
};

export default JiraIssueStatus;
